<template>
  <div class="edit-platform">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">审核扣款</div>
    <div class="order-detail-basic">
      <el-form :model="info" ref="ruleForm" hide-required-asterisk label-width="100px" class="demo-ruleForm">
        <el-form-item label="平台号:" prop="num"> {{ info.store && info.store.code }} </el-form-item>
        <el-form-item label="平台名称:"> {{ info.store && info.store.name }} </el-form-item>
        <el-form-item label="扣款金额:"> {{ info.amount }} </el-form-item>
        <el-form-item label="支付方式:"> {{ $config.accountType[info.accountType] }} </el-form-item>
        <el-form-item label="备注:"> {{ info.remark }} </el-form-item>
      </el-form>
      <div class="edit-button" v-if="info.tradeStatus === 'APPLY' && $hasPermission('epay:admin:deduct:modify')">
        <el-button round @click="audit(false)" :loading="loadingRefuse">审核拒绝</el-button>
        <el-button type="primary" round @click="audit(true)" :loading="loading">审核通过</el-button>
      </div>
      <div class="edit-button" v-else>
        <el-button type="primary" round @click="$router.go(-1)">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { adminDeductGet, adminDeductHandle } from '@/api/epay'
export default {
  name: 'edit-platform',
  components: {
  },
  data () {
    return {
      info: {},
      loading: false,
      loadingRefuse: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.init()
  },
  methods: {
    audit (a) {
      if (a) {
        this.loading = true
      } else {
        this.loadingRefuse = true
      }

      adminDeductHandle({
        action: a ? 'audit' : 'reject',
        orderId: this.info.orderId
      })
        .then(res => {
          if (res.data.success) {
            this.$message.success('操作成功')
            this.$router.go(-1)
            this.loading = false
            this.loadingRefuse = false
          }
        })
    },
    init () {
      adminDeductGet(this.$route.query.id)
        .then(res => {
          if (res.data.success) {
            this.info = res.data.data
          }
        })
    }

  }
}
</script>
<style scoped lang="less">
// @import "index";
.edit-platform {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

@deep: ~">>>";
</style>
